<!--框架-->
<template>
    <v-app>
        <v-container fluid width="100%" height="100%" style="padding: 0;">
           <!-- {{$route.meta}} -->
            <!-- 左侧菜单列表  10.4em permanent   color="#545c64"-->
            <v-navigation-drawer
                :value="showNavigation"
                app
                width="10%"
                heigth="100%"
                mini-variant
                mini-variant-width="9em"
                :color="theme.navigationDrawerBgColor"
                stateless
            >
                <div class="mt-5 ml-11">
                    <div class="atom-spinner">
                        <div class="spinner-inner">
                            <div class="spinner-line"></div>
                            <div class="spinner-line"></div>
                            <div class="spinner-line"></div>
                            <div class="spinner-circle">
                                <v-img width="6vh" height="6vh" src="@/assets/logo.png"></v-img>
                            </div>
                        </div>
                    </div>
                </div>
                <div style="font-size:1vh;color:#ff0000" class="mt-5 ml-11">
                    <!-- {{ permissions(user.role) }} -->
                </div>
                <!-- 下拉菜单列表 background-color="#545c64" -->
                <nav-menu :mode="'vertical'" :groupTopClass="'ml-n4'" :itemTopClass="'ml-n1'" />
            </v-navigation-drawer>
            <!-- 顶部内容 -->
            <div style="width:100%;height:90%;" v-if="$route.meta.title != '大数据展示屏'">
                <keep-alive>
                    <router-view
                        v-if="$route.meta.keepAlive"
                        :style="{ marginTop: navigationMode == 'vertical' ? '3vh' : '10vh' }"
                    ></router-view>
                </keep-alive>
                <router-view
                    v-if="!$route.meta.keepAlive"
                    :style="{ marginTop: navigationMode == 'vertical' ? '3vh' : '10vh' }"
                ></router-view>
            </div>
            <!-- 大数据展示屏 -->
            <div style="padding: 0;"  v-else>
                <router-view
                    v-if="!$route.meta.keepAlive"
                ></router-view>
            </div>
        </v-container>
    </v-app>
</template>

<script>
import util from "@/util";
import store from "@/store";
import NavMenu from "@/components/NavMenu";
import { mapState } from "vuex";
import axios from "axios";
import Public from "@/public";
export default {
    name: "Home",
    data() {
        return {
            dropdown_icon: "el-icon-arrow-left el-icon--right ml-n2",
            theme_icon: "el-icon-moon",
        };
    },
    components: {
        NavMenu,
    },
    computed: {
        ...mapState([
            "siteList",
            "user",
            "allArea",
            "siteInfo",
            "theme",
            "navigationMode",
            "showNavigation",
            "faultData",
        ]),
    },
    watch: {
        siteList: {
            handler(val) {
                if (val === []) {
                    // this.getAreaCode();
                    this.getArea();
                }
            },
            deep: true,
        },
    },
    async mounted() {
        if (document.getElementById("message")) {
            document.getElementById("message").setAttribute("id", "alrem");
        }

        if (this.theme.topBarBgColor == "#2C2C43") {
            this.theme_icon = "el-icon-sunny";
        } else {
            this.theme_icon = "el-icon-moon";
        }
        await this.getArea();
    },
    methods: {
        async getArea() {
            await store.dispatch("getArea", {});
            let areaCode = [];
            for (let i = 0; i < this.allArea.length; i++) {
                areaCode.push({
                    label: this.allArea[i],
                    children: [],
                });
            }
            await this.getSite(areaCode);
        },
        async getSite(area) {
            let areaCode = area;
            let promiseArr = [];
            let postDataArr = [];
            for (let i = 0; i < areaCode.length; i++) {
                let postData = {
                    area_code: areaCode[i].label,
                    from: 0,
                    limit: 10000,
                };
                await store.dispatch("getSite", postData);
                let promise = new Promise((resolve, reject) => {
                    resolve(this.siteInfo);
                });
                promiseArr.push(promise);
            }
            Promise.allSettled(promiseArr)
                .then(result => {
                    for (let i = 0; i < result.length; i++) {
                        if (result[i].status === "fulfilled") {
                            let data = result[i].value;
                            for (let j = 0; j < data.length; j++) {
                                areaCode[i].children[j] = {
                                    id: data[j].id,
                                    value: data[j].name,
                                    cec_id: data[j].cec_id,
                                    status: data[j].status
                                };
                            }
                            areaCode[i].children.sort(Public.createComprisonFunction2("value"));
                        } else {
                            util.ShowTip(result[i].status, 2);
                        }
                    }
                    areaCode.sort(Public.createComprisonFunction2("label"));
                    store.commit("SET_SITE_LIST", areaCode);
                })
                .catch(error => {
                    util.ShowTip(error, 2);
                });
        },
        /*权限*/
        permissions(role) {
            if (role === 0) {
                return "超级管理员";
            } else return "管理员";
        },
        JsonData(data) {
            return JSON.parse(JSON.stringify(data));
        },
        /*首页导航中退出登录*/
        logOut() {
            store.commit("LOG_OUT");
        },
        /*首页导航中 鼠标移入用户名*/
        move() {
            this.dropdown_icon = "el-icon-arrow-down  el-icon--right ml-n2";
        },
        /*首页导航中 鼠标移出用户名*/
        out() {
            this.dropdown_icon = "el-icon-arrow-left  el-icon--right ml-n2";
        },
        /*主题切换*/
        subjectSwitch() {
            let theme;
            if (this.theme_icon == "el-icon-moon") {
                this.theme_icon = "el-icon-sunny";
                theme = {
                    topBarBgColor: "#2C2C43", // 头部背景颜色
                    projectNameColor: "#F7F7F7", //名称颜色
                    userNameColor: "#A8A9BB", //用户名颜色
                    titleBgColor: "#2C2C43", //标题背景颜色
                    titleFontColor: "#CACBD6", //标题字体颜色
                    navigationDrawerBgColor: "#222233", //左边导航背景颜色
                    navigationDrawerFontColor: "#F4F4F5", //左边导航字体颜色
                    activeDrawerFontColor: "#595959", //左边导航点击后的字体颜色
                    pageBgColor: "#2C2C43", //页面背景颜色
                    pageFontColor: "#A8A9BB", //页面上的字体颜色
                    elementBgColor: "#222233", //页面上的元素背景
                    tableDark: true,
                };
            } else {
                this.theme_icon = "el-icon-moon";
                theme = {
                    topBarBgColor: "white", // 头部背景颜色
                    projectNameColor: "#4dabf7", //名称颜色
                    userNameColor: "#343a40", //用户名颜色
                    titleBgColor: "#4dabf7", //标题背景颜色
                    titleFontColor: "white", //标题字体颜色
                    navigationDrawerBgColor: "#545c64", //左边导航背景颜色
                    navigationDrawerFontColor: "#fff", //左边导航字体颜色
                    activeDrawerFontColor: "#4dabf7", //左边导航点击后的字体颜色
                    pageBgColor: "#e9ecef", //页面背景颜色
                    pageBgColor: "#e9ecef", //页面背景颜色
                    pageFontColor: "#303133", //页面上的字体颜色
                    elementBgColor: "#FFFFFF", //页面上的元素背景
                    tableDark: false,
                };
            }
            store.commit("SET_THEME", theme);
        },
        /*点击首页导航中的故障信息提示*/
        clickAlrem() {
            if (document.getElementById("alrem")) {
                document.getElementById("alrem").removeAttribute("id");
            }
            this.$emit("open");
        },
    },
};
</script>

<style scoped lang="scss">
#alrem {
    -webkit-animation: sucaijiayuan 1s 0.1s ease both infinite;
}
@-webkit-keyframes sucaijiayuan {
    0% {
        -webkit-transform: scale(1);
    }
    10%,
    20% {
        -webkit-transform: scale(0.8) rotate(-5deg);
    }
    30%,
    50%,
    70%,
    90% {
        -webkit-transform: scale(1.1) rotate(10deg);
    }
    40%,
    60%,
    80% {
        -webkit-transform: scale(1.1) rotate(-15deg);
    }
    100% {
        -webkit-transform: scale(1) rotate(0);
    }
}
.atom-spinner,
.atom-spinner * {
    box-sizing: border-box;
}

.atom-spinner {
    height: 60px;
    width: 60px;
    overflow: hidden;
}

.atom-spinner .spinner-inner {
    position: relative;
    display: block;
    height: 100%;
    width: 100%;
}

.atom-spinner .spinner-circle {
    display: block;
    position: absolute;
    color: #ff1d5e;
    font-size: calc(60px * 0.24);
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

.atom-spinner .spinner-line {
    position: absolute;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    animation-duration: 1s;
    border-left-width: calc(60px / 25);
    border-top-width: calc(60px / 25);
    border-left-color: #5c5edc;
    border-left-style: solid;
    border-top-style: solid;
    border-top-color: transparent;
}

.atom-spinner .spinner-line:nth-child(1) {
    animation: atom-spinner-animation-1 1s linear infinite;
    transform: rotateZ(120deg) rotateX(66deg) rotateZ(0deg);
}

.atom-spinner .spinner-line:nth-child(2) {
    animation: atom-spinner-animation-2 1s linear infinite;
    transform: rotateZ(240deg) rotateX(66deg) rotateZ(0deg);
}

.atom-spinner .spinner-line:nth-child(3) {
    animation: atom-spinner-animation-3 1s linear infinite;
    transform: rotateZ(360deg) rotateX(66deg) rotateZ(0deg);
}

@keyframes atom-spinner-animation-1 {
    100% {
        transform: rotateZ(120deg) rotateX(66deg) rotateZ(360deg);
    }
}

@keyframes atom-spinner-animation-2 {
    100% {
        transform: rotateZ(240deg) rotateX(66deg) rotateZ(360deg);
    }
}

@keyframes atom-spinner-animation-3 {
    100% {
        transform: rotateZ(360deg) rotateX(66deg) rotateZ(360deg);
    }
}
</style>
